import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SaveQuoteDialog } from '@app/models/dialogText/SaveQuoteDialog';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ProposalLimitInterceptor implements HttpInterceptor {
    constructor(private readonly dialog: MatDialog) { }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (this.isProposalPostRequest(req) && error.status === 429) {
                    this.closeSaveQuoteDialog();
                }

                return throwError(error);
            })
        );
    }

    /**
     * Closes the SaveQuoteDialog "Saving, please wait" spinner when a proposal submit
     * is rate limited (429). The dialog is opened with disableClose, so it must be
     * dismissed explicitly.
     */
    private closeSaveQuoteDialog(): void {
        this.dialog.getDialogById(SaveQuoteDialog.id)?.close();
    }

    private isProposalPostRequest(req: HttpRequest<any>): boolean {
        return (
            req.method === 'POST' && req.url.includes('/api/v1/Proposals')
        );
    }
}
